<template>
  <div class="label-list">
    <div class="label-list-info" ref="menu">
      <div class="label-list-info-row">
        <span class="label-list-info-name">当前设备</span>
        <el-select
          size="small"
          :value="deviceId"
          @input="setDevice"
          placeholder="设备切换"
        >
          <el-option
            v-for="item in teles"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </div>

      <div class="label-list-info-row">
        <span class="label-list-info-name">默认标签</span>
        <el-select
          size="small"
          :value="defaultLabel"
          @input="setDefault"
          filterable
          placeholder="设置默认标签"
        >
          <el-option
            v-for="item in cates"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </div>

      <div class="label-list-info-row">
        <span class="label-list-info-name">显示标签</span>
        <el-select
          size="small"
          :value="showLabel"
          @input="setShowLabel"
          placeholder="设置显示标签"
        >
          <el-option label="全部" :value="-1"> </el-option>
          <el-option
            v-for="item in showCategories"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </div>
    </div>

    <div class="label-list-main">
      <ul ref="scrollbar">
        <li v-if="!(insects && insects.length)" class="insect-item no-data">
          暂无数据
        </li>
        <li
          class="insect-item"
          v-for="(insect, index) in insects"
          :key="index"
          :class="{ actived: index === insectIndex }"
          @click="setInsect(index)"
          @dblclick="showEditContextMenu($event, index)"
          @contextmenu.prevent="e => showContextMenu(e, index)"
        >
          <el-checkbox
            :value="showLabel === -1 || showLabel === insect.categoryId"
            :disabled="!(showLabel === -1 || showLabel === insect.categoryId)"
          >
            {{ insect.category }}
          </el-checkbox>
        </li>
      </ul>
    </div>

    <context-menu ref="ctxMenu" @close="closeMenu">
      <my-select v-show="!edit" slot="menu">
        <select-item @click="edited">编辑标签</select-item>
        <select-item @click="remove">删除</select-item>
      </my-select>

      <my-select v-show="edit" slot="menu">
        <select-item
          v-for="item in cates"
          :key="item.id"
          :active="insect && item.id === insect.categoryId"
          @click="editInsect($event, item)"
        >
          {{ item.name }}
        </select-item>
      </my-select>
    </context-menu>
  </div>
</template>

<script>
import ContextMenu from '@/components/ContextMenu/index'
import MySelect from '@/components/Select'
import SelectItem from '@/components/Select/item'

export default {
  components: { ContextMenu, MySelect, SelectItem },
  props: {
    cates: {
      type: Array,
      default() {
        return []
      }
    },
    deviceId: Number,
    insects: Array,
    defaultLabel: Number,
    showLabel: Number,
    insectIndex: Number
  },
  data() {
    return {
      editIndex: -1,
      edit: false
    }
  },
  computed: {
    insect() {
      return this.insects[this.editIndex]
    },
    showCategories() {
      return this.cates.filter(c =>
        Boolean(this.insects.find(i => i.categoryId === c.id))
      )
    }
  },
  methods: {
    setDefault(id) {
      this.$emit('set-default', id)
    },
    setShowLabel(id) {
      this.$emit('set-show-label', id)
    },
    setDevice(id) {
      this.$emit('set-device', id)
    },
    setInsect(index) {
      this.$emit('set-insect', index)
    },
    showContextMenu(e, index) {
      this.editIndex = index
      this.$emit('set-insect', index)
      // const offset = this.$refs.menu.offsetHeight - this.$refs.scrollbar.scrollTop

      const par = {
        offsetY: e.offsetY - this.$refs.scrollbar.scrollTop - 80,
        offsetX: e.offsetX + 8,
        target: e.target
      }

      this.$refs.ctxMenu.showContextMenu(par)
    },
    showEditContextMenu(e, index) {
      this.editIndex = index
      this.edit = true
      this.$emit('set-insect', index)
      this.$refs.ctxMenu.showContextMenu(e)
    },
    closeMenu() {
      this.$refs.ctxMenu.close()
      this.edit = false
    },
    edited(e) {
      e.stopPropagation()
      if (this.editIndex >= 0) {
        this.edit = true
      }
    },
    remove(e) {
      e.stopPropagation()
      if (this.editIndex >= 0) {
        this.$emit('remove', this.editIndex)
        this.editIndex = -1
      }
      this.closeMenu()
    },
    editInsect(e, item) {
      e.stopPropagation()
      if (this.insect && this.insect.categoryId === item.id) return
      this.$emit('edit-insect', this.editIndex, item)
      this.closeMenu()
    }
  }
}
</script>

<style lang="scss" scoped>
.label-list {
  flex: 1;
  border-bottom: 1px solid #c1c1c1;
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: #d1d1d1;
}
.label-list-info {
  // height: 200px;
  border-bottom: 1px dashed #c1c1c1;
  background-color: #d1d1d1;
  padding: 8px;
  box-sizing: border-box;
  height: 142px;
}
.label-list-info-row {
  display: flex;
  justify-content: space-around;
  align-items: center;
  .label-list-info-name {
    color: #606266;
    font-size: 14px;
  }
  .el-select {
    width: 140px;
  }
}
.label-list-info-row:not(:last-child) {
  margin-bottom: 12px;
}
.label-list-main {
  font-size: 14px;
  color: #303133;
  padding-top: 0;
  box-sizing: border-box;
  height: calc(100% - 150px);
  ul {
    list-style: none;
    padding: 0;
    padding-top: 8px;
    margin: 0;
    overflow: auto;
    height: 100%;
    background-color: #fff;
    box-sizing: border-box;
  }
  .insect-item {
    padding: 0 0 8px 24px;
    user-select: none;
    cursor: pointer;
  }
  .insect-item.no-data {
    padding: 0;
  }
  .insect-item .el-checkbox {
    pointer-events: none;
  }
}
</style>

<style>
.insect-item.actived .el-checkbox__label {
  font-weight: bold;
  color: red;
}
</style>
